import { render, staticRenderFns } from "./customerDesk.vue?vue&type=template&id=3df55d10&scoped=true&"
import script from "./customerDesk.vue?vue&type=script&lang=js&"
export * from "./customerDesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df55d10",
  null
  
)

export default component.exports